define('validation--counter-ratings',["exports"], function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function () {
        var questions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];


        if (!Array.isArray(questions)) {
            return false;
        }

        return questions.length && questions.length === questions.filter(function (o) {
            return document.querySelector("input[name=\"" + o.id + "\"]:checked");
        }).length ? true : false;
    };
});
